import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { NIVELES_TROFEOS_CERTAMEN } from '../../providers/busqueda-tesoro/busqueda-tesoro-niveles';
import { BusquedaTesoroProvider } from '@providers/busqueda-tesoro/busqueda-tesoro';
import { AuthProvider } from '@providers/auth/auth';
import { LoadingProvider } from '@providers/loading/loading';


@IonicPage()
@Component({
  selector: 'page-busqueda-tesoro-niveles',
  templateUrl: 'busqueda-tesoro-niveles.html',
})
export class BusquedaTesoroNivelesPage {

  NIVELES = NIVELES_TROFEOS_CERTAMEN;
  busquedaTesoro: any;
  estatusCertamen: any;
  equipo: any;
  jugador: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private busquedaTesoroProvider: BusquedaTesoroProvider,
    private authProvider: AuthProvider,
    private loadingProvider: LoadingProvider,
  ) {
    this.busquedaTesoro = this.navParams.get('busquedaTesoro');

    // this.lottieConfig = {
    //      path: 'https://assets5.lottiefiles.com/packages/lf20_J4up3b.json',
    //      renderer: 'svg',
    //      autoplay: true,
    //      loop: true
    //  }
  }

  async ionViewDidLoad() {
    this.equipo = await this.authProvider.getEquipo();
    this.jugador = await this.authProvider.getSession();
    this.getStatus();
  }

  async getStatus() {
    this.loadingProvider.show(true);
    let response = await this.busquedaTesoroProvider.nivelUsuario(this.equipo.area._id, this.jugador._id);
    this.estatusCertamen = response;
    this.loadingProvider.show(false);
  }

  seleccionaIsla() {
    if(!this.estatusCertamen) return false;

    const shake = this.estatusCertamen.niveles.filter( n => !n.esCompletado).length;

    return shake ? false: true;
  }

  getClassNivel(uuid, index) {
    if(!this.estatusCertamen) return '';

    let nivel = this.estatusCertamen.niveles.find( n => n.uuid === uuid);
    let shake = this.estatusCertamen.niveles.filter( n => !n.esCompletado).length;

    if(nivel) {
      return nivel.esCompletado? 'active': 'active rotate-right';
    }

    if(!shake) {
      return  index%2 ? 'rotate-right': 'rotate-left';
    }
  }

  getStatusNivel(uuid) {
    if(!this.estatusCertamen) return false;

    let nivel = this.estatusCertamen.niveles.find( n => n.uuid === uuid);

    return nivel? nivel.esCompletado : false
  }

  esNivelActual(uuid) {
    if(!this.estatusCertamen) return false;

    let nivel = this.estatusCertamen.niveles.find( n => n.uuid === uuid);

    return nivel && nivel.esCompletado === false;
  }

  getAvanceID(uuid) {
    if(!this.estatusCertamen) return null;

    let nivel = this.estatusCertamen.niveles.find( n => n.uuid === uuid);

    return nivel ? nivel._id : null;
  }

  getNivel(uuid) {
    if(!this.estatusCertamen) return null;

    return this.estatusCertamen.niveles.find( n => n.uuid === uuid);
  }

  bloquearNiveles() {
    if(!this.estatusCertamen) return false;

    return this.estatusCertamen.niveles.length != 0 && this.estatusCertamen.niveles.filter( n => !n.esCompletado ).length > 0;
  }

  muestaTemploSabios() {
    if(!this.estatusCertamen) return false;

    return (this.estatusCertamen.premiosGanados.llaves + this.estatusCertamen.premiosGanados.cofres ) == 6;
  }

}



// WEBPACK FOOTER //
// ./src/pages/busqueda-tesoro-niveles/busqueda-tesoro-niveles.ts